import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ChangesSubject, DataChangesObserver, Logger, TitleService} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ToasterService} from 'angular2-toaster';
import {BsModalService} from 'ngx-bootstrap/modal';

import {SettingsService} from '../../pages-services/';
import {ConfirmPopupComponent} from '../../components';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
    haveChanges = false;
    changesCount = 0;
    publishVersion = '';
    publishVersionsList: Array<{ version: string, publishedAt: string }> = [];
    isPublishing = false;
    imagePacks = [];
    selectedImagePack = null;
    isPackageUploading = false;
    choices = [
        {name: 'Muiltichoice', id: true},
        {name: 'Singlechoice', id: false}
    ];
    settings = {
        main: {
            icon: '',
            name: '',
            markets: []
        },
        email: {} as { isSmtp: boolean, emailFrom: string, smtp: { host: string, port: number, isSecure: boolean, auth: { user: string, password: string } } },
        theme: {} as { foreground: string, background: string, font: string },
        social: [] as Array<{ name: string, url: string, appId?: string }>,
        categories: [],
        all_subcategories: [],
        all_locates: [],
        all_drops: [],
        loading: true,
    };
    changesSubject: ChangesSubject;
    // isLoading = !Object.keys(this.settings).length;
    selectedCategories = {};
    selectedSubcategories = {};

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(private title: TitleService,
                private logger: Logger,
                private route: ActivatedRoute,
                private settingsService: SettingsService,
                private toasterService: ToasterService,
                private translateService: TranslateService,
                private translationService: TranslateService,
                private container: ElementRef,
                private datachanges: DataChangesObserver,
                private modalService: BsModalService) {
    }

    ngOnInit() {
        this.logger.debug('in dashboard: ', this.route.snapshot.data);
        this.title.setTitle(this.route.snapshot.data.title ? this.route.snapshot.data.title : '');
        this.getSettingsData();
        this.settingsService.loadPublishVersionsList().subscribe((data) => {
            this.publishVersionsList = data.versions;
            // this.publishVersion = data.active;
        });
    }

    saveSettingsData() {
        this.settingsService.saveSettings(this.settings).subscribe(async (settings) => {
            this.settings = this.createChangesObservation(settings);
            let successMessage = await this.translateService.get('webpanel.save.settings.success_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });
    }

    getSettingsData() {
        this.settingsService.getSettings().subscribe(settings => {
            if (settings.img_packages.data) {
                settings.img_packages.data.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
                settings.img_packages.data = settings.img_packages.data.map((r) => {
                    r.isActive = false;
                    return r;
                });
                settings.img_packages.data.unshift({
                    id: -1,
                    createdAt: '',
                    updatedAt: null,
                    isActive: true,
                    size: 'New package'
                });
                settings.img_packages.activeEntity = -1;
            }
            this.logger.debug(settings.img_packages);
            this.settings = this.createChangesObservation(settings);
        });
    }

    isLoading() {
        return this.settings.loading;
    }

    toggleMarketCheckbox(language) {
        const index = this.settings.main.markets.indexOf(language);
        if (index !== -1) {
            this.settings.main.markets.splice(index, 1);
        } else {
            this.settings.main.markets.push(language);
        }
    }

    isCountryChecked(language) {
        return this.settings.main.markets.indexOf(language) !== -1;
    }

    cancelChanges() {
        if (this.changesSubject) {
            this.changesSubject.cancelChanges();
        }
    }

    private createChangesObservation(settings) {
        this.changesCount = 0;
        this.haveChanges = false;
        let subject = this.datachanges.observe(settings);
        this.changesSubject = subject;
        subject.onChanges.subscribe((event) => {
            this.changesCount = event.subject.changesCount;
            this.haveChanges = this.changesCount > 0;
        });
        return subject.getProxy();
    }

    async publish() {
        this.confirmPopup.show();
        this.isPublishing = true;
    }

    contains(arr, obj: {field: string, value: string}): boolean {
        return arr.find((r) => r[obj.field] === obj.value) !== undefined;
    }

    indexOf(arr, obj: {field: string, value: string}): number {
        let index = -1;
        arr.forEach((r, i) => {
            if(this.contains(arr, obj)){
                index = i;
            }
        });
        return index;
    }

    allowedPlaceholders = 'Allowed placeholders: {{name}}, {{email}}, {{feedback}}';

    doPublish(res) {
        if (res) {
            this.settingsService.publish(this.publishVersion).subscribe(async (resp) => {
                let successMessage = await this.translationService.get('webpanel.settings.publish.success_message').toPromise();
                this.toasterService.pop('success', '', successMessage);
                this.settingsService.loadPublishVersionsList().subscribe((data) => {
                    this.publishVersionsList = data.versions;
                    this.publishVersion = data.active;
                    this.isPublishing = false;
                });
            });
        } else {
            this.isPublishing = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.component.ts